import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/addresschecked.png'
import _imports_1 from '@/assets/icon/addressnotchecked.png'


const _withScopeId = n => (_pushScopeId("data-v-f416f252"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-info" }
const _hoisted_2 = { class: "cart-contents contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_5 = { class: "cart-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tipstitle" }, "确认订单", -1))
const _hoisted_7 = {
  key: 0,
  class: "tips"
}
const _hoisted_8 = {
  key: 0,
  class: "order-address"
}
const _hoisted_9 = { class: "order-header" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "add-cart" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-zuojiantou" }),
  /*#__PURE__*/_createElementVNode("a", { href: "/cart" }, "返回购物车")
], -1))
const _hoisted_13 = { class: "address-list" }
const _hoisted_14 = { class: "address-left" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "phone" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "editAddress" }, "修改本地址", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiahao" }, null, -1))
const _hoisted_24 = { class: "cart-contents-info" }
const _hoisted_25 = {
  key: 0,
  class: "list"
}
const _hoisted_26 = { style: {"font-size":"16px","color":"#333333"} }
const _hoisted_27 = {
  key: 2,
  class: "youhuiquan"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "优惠券", -1))
const _hoisted_29 = { class: "left" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "order-details-remarks-title" }, "买家留言", -1))
const _hoisted_31 = { class: "right" }
const _hoisted_32 = { class: "order-details-contents" }
const _hoisted_33 = {
  key: 0,
  class: "share"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lefts" }, "商品金额", -1))
const _hoisted_35 = { class: "rights" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lefts" }, "咨询服务", -1))
const _hoisted_38 = { class: "rights" }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lefts" }, "会员优惠", -1))
const _hoisted_41 = { class: "rights decoration-right" }
const _hoisted_42 = { class: "decoration" }
const _hoisted_43 = { key: 3 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lefts" }, "折扣优惠", -1))
const _hoisted_45 = { class: "rights decoration-right" }
const _hoisted_46 = { class: "decoration" }
const _hoisted_47 = { key: 4 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lefts" }, "优惠券", -1))
const _hoisted_49 = { class: "rights decoration-right" }
const _hoisted_50 = { class: "decoration" }
const _hoisted_51 = { class: "total-price" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lefts" }, "实付款", -1))
const _hoisted_53 = { class: "rights total" }
const _hoisted_54 = {
  key: 0,
  class: "address-show"
}
const _hoisted_55 = { class: "info" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加收货地址", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_current_address = _resolveComponent("current-address")!
  const _component_dialog_share = _resolveComponent("dialog-share")!
  const _component_goods_item = _resolveComponent("goods-item")!
  const _component_goods_real_item = _resolveComponent("goods-real-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_GoodsPrice = _resolveComponent("GoodsPrice")!
  const _component_consulting_select = _resolveComponent("consulting-select")!
  const _component_cart_numbers = _resolveComponent("cart-numbers")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Ayouhuiquan = _resolveComponent("Ayouhuiquan")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_html_footer = _resolveComponent("html-footer")!
  const _component_Title = _resolveComponent("Title")!
  const _component_AddressFrom = _resolveComponent("AddressFrom")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PayDialog = _resolveComponent("PayDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_current_address, null, {
          address: _withCtx(() => [
            _createVNode(_component_router_link, { to: {
								name: 'home',
							} }, {
              default: _withCtx(() => [
                _createTextVNode("首页")
              ]),
              _: 1
            }),
            _createTextVNode(" > "),
            _createVNode(_component_router_link, { to: {
								name: 'myorder',
							} }, {
              default: _withCtx(() => [
                _createTextVNode("我的订单")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_4
      ]),
      _createElementVNode("p", _hoisted_5, [
        _hoisted_6,
        (_ctx.orderType == 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "虚拟商品不得退换"))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isSend)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, [
                _createTextVNode(" 收货地址及联系方式"),
                (_ctx.orderType == 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "提示：该订单包含加密狗，需要邮寄"))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_12
            ]),
            _createElementVNode("ul", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressList.data, (address, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass({ 'address-li': address.isSelect })
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    (address.isSelect)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _imports_0,
                          onClick: ($event: any) => (_ctx.changeAddress(index))
                        }, null, 8, _hoisted_15))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _imports_1,
                          onClick: ($event: any) => (_ctx.changeAddress(index))
                        }, null, 8, _hoisted_16)),
                    _createElementVNode("span", null, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.changeAddress(index))
                      }, [
                        _createTextVNode(_toDisplayString(address.province) + " " + _toDisplayString(address.city) + " " + _toDisplayString(address.area) + " " + _toDisplayString(address.address) + " （" + _toDisplayString(address.contacts) + " 收） ", 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(address.phonenumber), 1)
                      ], 8, _hoisted_17),
                      (address.default != 1)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "address-edit",
                            onClick: ($event: any) => (_ctx.setDefaultAddress(index))
                          }, " 设置为默认收货地址 ", 8, _hoisted_19))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "address-right",
                    onClick: ($event: any) => (_ctx.updateAddress(address))
                  }, _hoisted_22, 8, _hoisted_20)
                ], 2))
              }), 256))
            ]),
            (_ctx.addressList.data && _ctx.addressList.data.length < 3)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "add-address",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDialogVisible()))
                }, [
                  _hoisted_23,
                  _createTextVNode("添加地址 ")
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showShareUrl)
        ? (_openBlock(), _createBlock(_component_dialog_share, {
            key: 1,
            onCancel: _ctx.cancel
          }, null, 8, ["onCancel"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        (_ctx.cartData.datas && _ctx.cartData.datas.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_el_table, {
                data: _ctx.cartData.datas,
                ref: "multipleTableRef",
                style: {"width":"100%"},
                "header-row-class-name": "title-name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "date",
                    label: "商品信息",
                    width: "590"
                  }, {
                    default: _withCtx((scope) => [
                      (_ctx.orderType == 0)
                        ? (_openBlock(), _createBlock(_component_goods_item, {
                            key: 0,
                            data: scope.row
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true),
                      (_ctx.orderType == 1)
                        ? (_openBlock(), _createBlock(_component_goods_real_item, {
                            key: 1,
                            data: scope.row
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "商品价格",
                    width: "258"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_GoodsPrice, {
                        data: scope.row
                      }, null, 8, ["data"])
                    ]),
                    _: 1
                  }),
                  (_ctx.orderType == 0)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        label: "咨询服务",
                        width: "385"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_consulting_select, {
                            cartId: parseInt(scope.row.id),
                            counsel: _ctx.getCounsel(scope.row.counsel),
                            onChangeCounsel: _ctx.changeCounsel
                          }, null, 8, ["cartId", "counsel", "onChangeCounsel"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 1,
                        label: "数量",
                        width: "385"
                      }, {
                        default: _withCtx((scope) => [
                          (_ctx.orderType == 1)
                            ? (_openBlock(), _createBlock(_component_cart_numbers, {
                                key: 0,
                                data: scope.row,
                                index: scope.$index,
                                onHandleNumbersChange: _ctx.handleNumbersChange
                              }, null, 8, ["data", "index", "onHandleNumbersChange"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.orderType == 0 ? '小计/枚' : '小计（含税）',
                    width: "207"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", _hoisted_26, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["icon iconfont", {
											'icon-a-Group14379': scope.row.is_real_goods == 0,
											'icon-renminbi': scope.row.is_real_goods == 1,
											'icon-renminbi-price': scope.row.is_real_goods == 1,
										}])
                        }, null, 2),
                        _createTextVNode(_toDisplayString(_ctx.showPrice(_ctx.getItemPrice(scope.row), scope.row.is_real_goods)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["data"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.couponList.data.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_Ayouhuiquan, {
              couponList: _ctx.couponList,
              couponsIndex: _ctx.couponsIndex
            }, null, 8, ["couponList", "couponsIndex"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["order-details", {
					'order-details-no': _ctx.couponList.data.length == 0,
					'real-goods': _ctx.orderType == 1,
				}])
      }, [
        _createElementVNode("div", _hoisted_29, [
          (_ctx.orderType == 1)
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 0,
                ref: "ruleFormRef",
                model: _ctx.ruleForm,
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "remarks",
                    class: "order-details-remarks"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.remarks,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.remarks) = $event)),
                        maxlength: "200",
                        autosize: { minRows: 5, maxRows: 8 },
                        placeholder: "选填，建议留言前与客服沟通确认",
                        "show-word-limit": "",
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            (_ctx.orderType == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", {
                    class: "share-tips",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hiddenShareUrl && _ctx.hiddenShareUrl(...args)))
                  }, "分享商品清单")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, [
              _hoisted_34,
              _createElementVNode("span", _hoisted_35, [
                _createElementVNode("i", {
                  class: _normalizeClass(["icon iconfont", {
										'icon-a-Group14379': _ctx.orderType == 0,
										'icon-renminbi': _ctx.orderType == 1,
									}])
                }, null, 2),
                _createTextVNode(_toDisplayString(_ctx.showPrice(_ctx.orderInfo.goodsPrice, _ctx.orderType)), 1)
              ])
            ]),
            (_ctx.orderInfo.servicePrice > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("span", _hoisted_38, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon iconfont", {
										'icon-a-Group14379': _ctx.orderType == 0,
										'icon-renminbi': _ctx.orderType == 1,
									}])
                    }, null, 2),
                    _createTextVNode(_toDisplayString(_ctx.orderInfo.servicePrice), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.orderInfo.vipPrice > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("span", _hoisted_41, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon iconfont", {
										'icon-a-Group14379': _ctx.orderType == 0,
										'icon-renminbi': _ctx.orderType == 1,
									}])
                    }, null, 2),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.orderInfo.vipPrice), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.orderInfo.actPrice > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("span", _hoisted_45, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon iconfont", {
										'icon-a-Group14379': _ctx.orderType == 0,
										'icon-renminbi': _ctx.orderType == 1,
									}])
                    }, null, 2),
                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.showPrice(_ctx.orderInfo.actPrice, _ctx.orderType)), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.couponList.data && _ctx.couponList.data.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", _hoisted_49, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon iconfont", {
										'icon-a-Group14379': _ctx.orderType == 0,
										'icon-renminbi': _ctx.orderType == 1,
									}])
                    }, null, 2),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.couponList.data[_ctx.couponsIndex].amount), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("span", _hoisted_53, [
                _createElementVNode("i", {
                  class: _normalizeClass(["icon iconfont", {
										'icon-a-Group14379': _ctx.orderType == 0,
										'icon-renminbi': _ctx.orderType == 1,
									}])
                }, null, 2),
                _createTextVNode(_toDisplayString(_ctx.showPrice(_ctx.orderInfo.payPrice, _ctx.orderType)), 1)
              ])
            ])
          ]),
          (_ctx.isSend)
            ? (_openBlock(), _createElementBlock("p", _hoisted_54, "寄送至： " + _toDisplayString(_ctx.selectAddress), 1))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_55, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPay())),
          round: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("立即付款")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_html_footer),
    _createVNode(_component_Dialog, {
      ref: "sonRef",
      dialogwidth: "625px",
      addressItems: _ctx.addressItem
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          title: _withCtx(() => [
            _hoisted_56
          ]),
          edit: _withCtx(() => [
            _createElementVNode("i", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.mclose(1))),
              class: "icon iconfont icon-shanchu",
              style: {"font-size":"12px"}
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({ addressItems }) => [
        _createVNode(_component_AddressFrom, {
          onMclose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mclose(1))),
          addressItem: addressItems
        }, null, 8, ["addressItem"])
      ]),
      _: 1
    }, 8, ["addressItems"]),
    _createVNode(_component_Dialog, {
      ref: "toPay",
      dialogwidth: "503px"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#fff"
        }, {
          edit: _withCtx(() => [
            _createElementVNode("i", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mclose())),
              class: "icon iconfont icon-shanchu",
              style: {"font-size":"12px"}
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_PayDialog, {
          creatOrderInfo: _ctx.creatOrderInfo,
          wrongtimes: _ctx.wrongtimes
        }, null, 8, ["creatOrderInfo", "wrongtimes"])
      ]),
      _: 1
    }, 512)
  ]))
}